class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_MULTIPLE_ADD,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_ITEM_QUANTITY,
      this.onCartChanged,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_UPDATE_REMOVE_ITEM,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return

    // Check if we have items in state to calculate count excluding child products
    if (state.items && Array.isArray(state.items)) {
      const count = this.calculateCountExcludingChildren(state.items)
      this.updateWithCount(count)
      this.setAttribute('aria-hidden', count === 0)
      return
    }

    // Check if we have item_count directly in state (fallback)
    if ('item_count' in state) {
      this.updateWithCount(state.item_count)
      return
    }

    // Fallback to section rendering method
    if (!state.sections) return
    if (!('push-cart-count' in state.sections)) return

    const newCartTotal = parseInt(
      this.getCount(state.sections['push-cart-count']),
    )

    this.updateWithCount(newCartTotal)
    this.setAttribute('aria-hidden', newCartTotal === 0)
  }

  /**
   * Calculate cart count excluding child/bundled items
   * @param {Array} items - Cart items array
   * @returns {number} - Count excluding children
   */
  calculateCountExcludingChildren (items) {
    let count = 0

    for (const item of items) {
      // Check if item has a parent_key (is a child/bundled item)
      const hasParentKey = item.parent_relationship?.parent_key
      const isChild = Boolean(hasParentKey)

      if (!isChild) {
        count += item.quantity
      }
    }

    return count
  } /**
   * @param {number} count
   *
   * @returns {void}
   */

  updateWithCount (count) {
    switch ((this.dataset.format || 'long')) {
      case 'short':
        this.textContent = String(count)
        return
      case 'long': {
        const singularLabel = this.dataset.labelSingular || 'Item'
        const pluralLabel = this.dataset.labelPlural || 'Items'
        const label = count === 1 ? singularLabel : pluralLabel
        this.textContent = `${count} ${label}`
      }
    }
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)
    const element = DOM.querySelector('#push-cart-count')

    // Extract just the number from the text content (before any HTML comments)
    const textContent = element.textContent || element.innerText || ''
    const match = textContent.match(/^\d+/)

    return match ? match[0] : '0'
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
